<template>
  <form data-vv-scope="tags-form" class="bg-white shadow rounded-lg mt-10 pt-4 pb-10">
    <b-alert variant="info" class="m-5" show>
      <div class="alert-body">
        <span class="text-sm text-gray-600">
          * Pincha sobre el candado para activar/desactivar esta sección.
        </span>
      </div>
    </b-alert>
    <!-- header -->
    <div class="px-2 py-2 pl-md-4 pr-md-4 ml-md-5 mr-md-5 justify-content-between d-flex">
      <span class="text-base leading-6 font-medium text-gray">
        Etiquetas <span class="badge badge-secondary">{{ elementTags.length }}</span>
      </span>
      <b-button
        @click="disabled = !disabled"
        :variant="disabled ? 'flat-danger' : 'flat-success'"
        class="btn-icon rounded-circle cursor-pointer border-none"
        :disabled="userPermissions.write === 0
          && userPermissions.totalControl === 0
          && !hasPermission('FEB99')"
        :class="{
          'cursor-not-allowed': userPermissions.write === 0
            && userPermissions.totalControl === 0
            && !hasPermission('FEB99')
        }"
      >
        <transition enter-active-class="animated fadeIn">
          <feather-icon v-if="disabled" icon="LockIcon"/>
        </transition>
        <transition enter-active-class="animated fadeIn">
          <feather-icon v-if="!disabled" icon="UnlockIcon"/>
        </transition>
      </b-button>
    </div>
    <!-- body -->
    <div class="border-t border-gray-200 m-5">
      <v-select
        v-model="elementTags"
        placeholder="Selecciona una o mas etiquetas existentes o crea una nueva."
        :options="companyTags"
        taggable
        multiple
        v-if="!disabled"
        @option:selecting="addElementTag"
        @option:selected="removeFails"
        @option:deselecting="deleteElementTag"
      >
        <template #search="{attributes, events}">
          <input
            name="tags"
            data-vv-as="Etiquetas"
            class="vs__search"
            v-validate="'alpha_num'"
            v-bind="attributes"
            v-on="events"
          />
        </template>
        <div slot="no-options">No existen opciones para seleccionar.</div>
      </v-select>
      <div v-else-if="elementTags.length" class="card">
        <div class="card-body">
          <b-badge
            class="cursor-not-allowed mr-3"
            v-for="(tag, index) in elementTags"
            variant="light-secondary"
            :key="`tag_${index}`"
          >
            {{ tag }}
          </b-badge>
        </div>
      </div>
      <FormError
        attributeName="tags-form.tags"
        :errorsForm="errors"
      />
    </div>
  </form>
</template>

<script>
import { mapGetters } from 'vuex';

import FormError from '@/febos/global/documentManagement/components/FormError';
import {
  ioEDFilesTagsAdd,
  ioEDFoldersTagsAdd,
  ioEDFoldersTagsDelete,
  ioEDFilesTagsDelete,
  ioEDFilesTagsList
} from '@/febos/servicios/api/repositories.api';

export default {
  name: 'EDTagsForm',
  data() {
    return {
      userPermissions: {
        read: 0,
        write: 0,
        totalControl: 0
      },
      companyTags: [],
      elementTags: [],
      disabled: true
    };
  },
  components: {
    FormError
  },
  mounted() {
    this.loadCompanyTags();
    this.loadPermissions();
  },
  methods: {
    async loadCompanyTags() {
      const response = await ioEDFilesTagsList({
        orden: encodeURIComponent('+tag'),
        campos: 'tag_id,tag',
        itemsPorPagina: '1000',
        pagina: '1'
      });
      const result = response.data.tags;
      this.companyTags = result.filter((item, index) => result.indexOf(item) === index);
    },
    async addElementTag(tag) {
      if (this.errors.all().length) {
        return;
      }
      if (this.getSelectedElement.type === 'file') {
        await ioEDFilesTagsAdd({
          tag,
          fileId: this.getSelectedElement.id,
          repositoryId: this.getSelectedElement.repositoryId
        });
      }
      if (this.getSelectedElement.type === 'folder') {
        await ioEDFoldersTagsAdd({
          tag,
          folderId: this.getSelectedElement.id,
          repositoryId: this.getSelectedElement.repositoryId
        });
      }
    },
    async deleteElementTag(tag) {
      if (this.getSelectedElement.type === 'folder') {
        await ioEDFoldersTagsDelete({
          tag,
          folderId: this.getSelectedElement.id,
          repositoryId: this.getSelectedElement.repositoryId
        });
      }
      if (this.getSelectedElement.type === 'file') {
        await ioEDFilesTagsDelete({
          tag,
          fileId: this.getSelectedElement.id,
          repositoryId: this.getSelectedElement.repositoryId
        });
      }
    },
    async removeFails() {
      if (this.errors.all().length) {
        this.elementTags.pop();
      }
    },
    loadPermissions() {
      const selected = this.getSelectedElement;
      this.userPermissions.read = selected.loggedUserPermissions.lectura;
      this.userPermissions.write = selected.loggedUserPermissions.escritura;
      this.userPermissions.totalControl = selected.loggedUserPermissions.controlTotal;
    }
  },
  computed: {
    ...mapGetters('Usuario', [
      'currentUser',
      'hasPermission'
    ]),
    ...mapGetters('DocManagement', [
      'getSelectedFolderId',
      'getSelectedElement',
      'getPermissionsStack'
    ])
  },
  watch: {
    getSelectedElement() {
      this.disabled = true;
      this.loadCompanyTags();
      this.elementTags = this.getSelectedElement.tags;
      this.loadPermissions();
    }
  }
};
</script>
